import { useEffect, useState } from "react";
import { useGetIncidentClosureFormsQuery } from "../../../features/Incidents/IncidentSlice";
import "survey-core/defaultV2.min.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import customTheme from "../IncidentForm/survey_theme.json";
import { Loader } from "../../common/Loader/Loader";

const ClosureForm = ({
  incidentId,
  handleSave,
  defaultValues,
  isLoading,
  setClosureFormIds,
}) => {
  const [incidentClosureFormsData, setIncidentClosureFormsData] = useState([]);
  const [currentOrder, setCurrentOrder] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [sortedData, setSortedData] = useState([]);

  const {
    data: incidentClosureForms,
    isLoading: incidentClosureFormsIsLoading,
    isSuccess: incidentClosureFormsIsSuccess,
    isError: incidentClosureFormsIsError,
  } = useGetIncidentClosureFormsQuery(incidentId);

  useEffect(() => {
    if (incidentClosureForms) {
      const data = incidentClosureForms.ids.map((id) => {
        return incidentClosureForms.entities[id];
      });

      const [closureForms] = data;
      if (closureForms?.forms.length > 0) {
        setSortedData(
          closureForms?.forms?.slice().sort((a, b) => a.order - b.order)
        );
        setIncidentClosureFormsData(closureForms);

        setClosureFormIds(
          closureForms.forms.map((form) => ({
            incidentFormId: form.incidentFormId,
            data: {},
          }))
        );
      }
    }
  }, [incidentClosureForms]);

  useEffect(() => {
    if (currentOrder >= incidentClosureFormsData?.forms?.length) {
      handleSave(answers);
    }
  }, [currentOrder]);

  function mergeObjectsFromArray(arr) {
    return arr.reduce(function (result, obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          result[key] = obj[key];
        }
      }
      return result;
    }, {});
  }

  const handleValueChanged = (options, sender) => {
    const questionName = options.name;
    const newValue = options.value;
  };

  if (incidentClosureFormsIsLoading) {
    return <Loader />;
  }

  if (incidentClosureFormsIsSuccess && !incidentClosureFormsIsLoading) {
    const form = sortedData[currentOrder];
    const formTemplate = form?.structure;

    const survey = new Model(formTemplate);
    survey.applyTheme(customTheme);

    if (!form) {
      return <></>;
    }

    survey.onComplete.add(function (sender, options) {
      const result = {
        incidentFormId: form.incidentFormId,
        data: sender.data,
      };
      setAnswers((prev) => [...prev, result]);
      setCurrentOrder((prev) => prev + 1);
    });

    return <Survey model={survey} onValueChanged={handleValueChanged} />;
  }
};

export default ClosureForm;
